import ErrorBox from '@components/common/ErrorBox';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
const focusOnError = createDecorator(); // must be outside the component
const MbmNotifyMeModal = (props) => {
    var _a;
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [requestSent, setRequestSent] = useState();
    const [errors, setErrors] = useState([]);
    // non renderizzare la modale all'apertura della pagina, non fare chiamate se non aperta
    const firstRender = useRef(true);
    useEffect(() => {
        if (props.isOpen && firstRender.current) {
            firstRender.current = false;
            let val = {};
            api.getForm('email', val).then((data) => {
                setInitialValues(val);
                setFormdef(data);
            });
        }
    }, [props.isOpen]);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'email');
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        api.mbmNotifymeSubmit(values, formdef).then((data) => {
            if (!data.success) {
                setErrors([t(data === null || data === void 0 ? void 0 : data.message)]);
            }
            else {
                let errors = {};
                if (!formutils.checkValidationAfterSubmit(data, errors)) {
                    return errors;
                }
                analytics.notifyMeSubmit('', props.productId, 'pdp', true);
                setRequestSent(values);
            }
        });
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(ModalDialog, { hideHeader: true, noPadding: true, isOpen: props.isOpen, onRequestClose: props.onRequestClose, id: "mbmNotifymeModal" },
        React.createElement("div", { className: "product-mbm-notify" },
            ((props === null || props === void 0 ? void 0 : props.imgs) || (props === null || props === void 0 ? void 0 : props.img)) && (React.createElement("div", { className: "mbm-notify-image" },
                React.createElement("img", { src: (props === null || props === void 0 ? void 0 : props.img) || (props === null || props === void 0 ? void 0 : props.imgs.urls[0]), alt: ((_a = props === null || props === void 0 ? void 0 : props.imgs) === null || _a === void 0 ? void 0 : _a.alt) || '' }))),
            requestSent ? (React.createElement(React.Fragment, null,
                React.createElement("h3", { role: "alert", className: "primary-m text-center mb-32" }, t('mbm.notifyconfirmtitle')),
                React.createElement("p", { className: "primary-s text-center", dangerouslySetInnerHTML: { __html: t('mbm.notifyconfirmtext') } }),
                React.createElement("div", { className: "mbm-finish__buttons" },
                    React.createElement(Button, { type: "button", cls: ['button--secondary'], onClick: () => {
                            if (props === null || props === void 0 ? void 0 : props.inConfigurator) {
                                if (props === null || props === void 0 ? void 0 : props.backToShopping) {
                                    window.location.href = props === null || props === void 0 ? void 0 : props.backToShopping;
                                }
                                else {
                                    window.location.href = window.homeurl;
                                    // history.back();
                                }
                            }
                            else {
                                props.onRequestClose();
                            }
                        } }, t('button.backtoshopping')),
                    (props === null || props === void 0 ? void 0 : props.editLink) ? (React.createElement("a", { href: props === null || props === void 0 ? void 0 : props.editLink, className: "button button--primary" },
                        React.createElement("span", null, t('mbm.configureyour')))) : (React.createElement(Button, { type: "button", cls: ['button--primary'], onClick: props.onRequestClose }, t('mbm.configureyour')))))) : (React.createElement(React.Fragment, null,
                React.createElement("h3", { className: "primary-m text-center mb-32" }, t('mbm.notifytitle')),
                React.createElement("p", { className: "primary-s text-center mbm-notify-text" }, t('mbm.notifytext')),
                React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues, decorators: [focusOnError], validate: (values) => validate(values), render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                        React.createElement(DwFormField, { def: formdef, name: "email" }),
                        React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'] }, t('button.mbmoos')))) }),
                React.createElement(ErrorBox, { errors: errors }))))));
};
export default MbmNotifyMeModal;
